import { useMemo } from "react";
import classnames from "classnames";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useOrganization } from "../../store/organization";

export function HeaderDescription() {
  const isMobile = useMediaQuery("(max-width:600px)");

  const { organization } = useOrganization();
  const landingDetails = organization.data.landingDetails;

  const videoSize = useMemo(() => ({
    width: isMobile ? 343 : 600,
    height: isMobile ? 194 : 339,
  }), [isMobile]);

  return (
    <div
      className={classnames("tw-mt-20 tw-w-full tw-px-4", {
        "tw-pt-8": isMobile,
        "tw-pt-12": !isMobile,
      })}
    >
      <h2 className="tw-font-bold tw-text-center tw-text-2xl">{landingDetails.headerText}</h2>
      <p className="tw-text-center tw-pt-2 tw-pb-8">{landingDetails.subHeader}</p>

      {/** We need to save only videoID [6EUeM9Zp5do] */}
      <div className="tw-flex tw-justify-center">
        <iframe
          width={videoSize.width}
          height={videoSize.height}
          src="https://www.youtube.com/embed/6EUeM9Zp5do"
          title="JackRabbit Super Portable and Ultralight Micro eBike" frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen>
        </iframe>
      </div>
    </div>
  );
}
